import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRightIcon, BrainIcon, TrophyIcon } from 'lucide-react';
export const Gallery: React.FC = () => {
  const cards = [{
    title: 'El Origen',
    subtitle: 'Madeira',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/w8ckRPuTnq7hjMeWUGN5Cw/Screenshot_2025-10-02_at_11.52.56_AM.png'
  }, {
    title: 'El Ascenso',
    subtitle: 'Sporting',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ptTeMGcA6KVxJaXQgSEurh/Screenshot_2025-10-02_at_12.26.17_PM.png'
  }, {
    title: 'La Transformación',
    subtitle: 'Manchester',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/opw7GSH7BvbReyksFbPPjE/Screenshot_2025-10-02_at_11.53.47_AM.png'
  }, {
    title: 'La Consagración',
    subtitle: 'Madrid',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qbftN39wypQ7LMtnMCh1wn/Screenshot_2025-10-02_at_11.54.05_AM.png'
  }, {
    title: 'El Retorno',
    subtitle: 'Manchester II',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eDCDfhiEuwcHEpZWdJLPMn/Screenshot_2025-10-02_at_11.53.17_AM.png'
  }, {
    title: 'La Conquista',
    subtitle: 'Turín',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/capm35as5PFMxKQXaarrsA/Screenshot_2025-10-02_at_12.02.45_PM.png'
  }];
  return <section className="pt-8 pb-20" data-id="element-95">
      <div className="text-center mb-16" data-id="element-96">
        <div className="inline-flex items-center justify-center p-3 bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full mb-8" data-id="element-97">
          <div className="px-6 py-2 bg-gradient-to-r from-[#E0B84C]/20 to-[#E0B84C]/20 text-[#E0B84C] text-base sm:text-lg font-medium rounded-full" data-id="element-98">
            ARTE EXCLUSIVO
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-99">
          Ilustraciones de Colección Digital
        </h2>
        <p className="text-lg text-[#CFCFCF] max-w-3xl mx-auto" data-id="element-100">
          6 ilustraciones exclusivas que capturan la esencia de un campeón. Cada
          una representa un capítulo de una historia legendaria.
        </p>
        <div className="mt-4 text-xs text-gray-500 max-w-2xl mx-auto" data-id="element-101">
          <p data-id="element-102">
            ⚠️ Todas las ilustraciones son creaciones artísticas estilizadas
            inspiradas en momentos icónicos, no fotografías oficiales. Arte
            conceptual creado por fans.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-103">
        {cards.map((card, index) => <div key={index} className="aspect-[3/4] relative group overflow-hidden rounded-lg border border-[#E0B84C]/30 hover:border-[#E0B84C] transition-all duration-300" data-id="element-104">
            {/* Card background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A] to-black" data-id="element-105"></div>
            {/* Card image if available */}
            {card.image && <img src={card.image} alt={card.title} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-106" />}
            {/* Abstract shape if no image */}
            {!card.image && <div className="absolute inset-0 flex items-center justify-center opacity-70 group-hover:opacity-100 transition-opacity duration-300" data-id="element-107">
                <div className="w-1/2 h-3/5 bg-[#E0B84C]/20 rounded-full blur-md transform group-hover:scale-110 transition-transform duration-300" data-id="element-108"></div>
              </div>}
            {/* Card number */}
            <div className="absolute top-4 left-4 w-8 h-8 rounded-full bg-[#0A0A0A]/70 border border-[#E0B84C]/50 flex items-center justify-center text-[#E0B84C] font-bold z-10" data-id="element-109">
              {index + 1}
            </div>
            {/* Card content */}
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent z-10" data-id="element-110">
              <h3 className="text-xl font-bold text-white" data-id="element-111">{card.title}</h3>
              <p className="text-[#E0B84C]" data-id="element-112">{card.subtitle}</p>
            </div>
            {/* Shine effect on hover */}
            <div className="absolute inset-0 bg-gradient-to-tr from-[#E0B84C]/0 to-[#E0B84C]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-113"></div>
          </div>)}
      </div>
      {/* Persuasive CTA section below the "La Mentalidad CR7" image */}
      <div className="mt-12 max-w-3xl mx-auto bg-gradient-to-b from-[#1A1A1A] to-[#0A0A0A] border border-[#E0B84C]/30 rounded-xl p-6 sm:p-8" data-id="element-114">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8" data-id="element-115">
          <div className="md:w-1/3" data-id="element-116">
            <div className="w-full aspect-square rounded-lg overflow-hidden border-2 border-[#E0B84C] shadow-lg" data-id="element-117">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/r5LHK7KoDUJqFKPFR9mm25/Screenshot_2025-10-02_at_1.01.44_PM.png" alt="La Mentalidad CR7" className="w-full h-full object-cover" data-id="element-118" />
            </div>
          </div>
          <div className="md:w-2/3 text-center md:text-left" data-id="element-119">
            <div className="inline-flex items-center mb-3 bg-[#E0B84C]/10 px-3 py-1 rounded-full" data-id="element-120">
              <BrainIcon className="w-4 h-4 text-[#E0B84C] mr-2" data-id="element-121" />
              <span className="text-[#E0B84C] text-sm font-medium" data-id="element-122">
                MENTALIDAD DE CAMPEÓN
              </span>
            </div>
            <h3 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-123">
              ¿Quieres la mentalidad de un campeón que ha conquistado el mundo?
            </h3>
            <p className="text-[#CFCFCF] mb-5" data-id="element-124">
              No es solo un libro. Es una{' '}
              <span className="text-white font-medium" data-id="element-125">
                transformación mental
              </span>
              . Descubre los secretos que han convertido a CR7 en una leyenda
              viviente y aplícalos a tu vida{' '}
              <span className="text-[#E0B84C]" data-id="element-126">hoy mismo</span>.
            </p>
            <Button className="text-base px-6 py-3 flex items-center justify-center gap-2 transform hover:scale-105 transition-all duration-300 shadow-lg shadow-[#22C55E]/20 w-full md:w-auto" href="https://store.collectiondigital.vip/cart/45861496684706:1" data-id="element-127">
              <TrophyIcon className="w-5 h-5" data-id="element-128" />
              <span className="font-bold" data-id="element-129">OBTÉN LA MENTALIDAD CR7 AHORA</span>
              <ArrowRightIcon className="w-5 h-5 ml-1" data-id="element-130" />
            </Button>
            <p className="text-xs text-[#FF3B30] mt-3 animate-pulse font-medium" data-id="element-131">
              ⚠️ SOLO QUEDAN POCAS COPIAS DISPONIBLES
            </p>
          </div>
        </div>
      </div>
    </section>;
};